import React, { useState, useEffect, useCallback } from 'react';
import * as echarts from 'echarts';
import BaseChart from '@components/common/BaseChart';
import { buildLineOption } from './utils';

const Chart = ({ data, type }) => {
  const [instance, setInstance] = useState<echarts.ECharts | null>(null);
  const chartInstanceRefCb: any = useCallback((instance) => {
    setInstance(instance);
  }, []);

  useEffect(() => {
    if (instance !== null) {
      const option = buildLineOption(data, type);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      instance.setOption(option, { notMerge: true });
    }
  }, [instance, data, type]);

  return (
    <BaseChart
      key="line-resiliency"
      chartId="line-resiliency"
      chartInstanceRefCb={chartInstanceRefCb}
      style={{ height: 500 }}
    />
  );
};

export default React.memo(Chart);
